import { gql, TypedDocumentNode } from "@apollo/client";

import { Query } from "types/generated";

export const GET_ACCOUNT_DELETION_DATA: TypedDocumentNode<{
  accountCanBeDeleted: Query["accountCanBeDeleted"];
  accountCanBeDeletedAt: Query["accountCanBeDeletedAt"];
  markedForDeletion: Query["markedForDeletion"];
}> = gql`
  query GetAccountDeletionData {
    accountCanBeDeleted
    accountCanBeDeletedAt
    markedForDeletion
  }
`;

export const TOGGLE_ACCOUNT_DELETION_MARK: TypedDocumentNode<{
  accountToggleDeletionMark: boolean;
}> = gql`
  mutation ToggleAccountDeletionMark {
    accountToggleDeletionMark
  }
`;

export const CONFIRM_ACCOUNT_DELETE: TypedDocumentNode<{
  accountConfirmDelete: boolean;
}> = gql`
  mutation ConfirmAccountDelete {
    accountConfirmDelete
  }
`;
